module.exports = __webpack_public_path__ + "assets/img/active_community_l1.21b50224.png";